import English from "./English";
import Hindi from "./Hindi";
import Bhojpuri from "./Bhojpuri";
import Punjabi from "./Punjabi";
import { useContext } from "react";
import { LanguageContext } from "../Contexts/LanguageContext";

const useTranslation = () => {
    const { state } = useContext(LanguageContext);
  
    switch (state.language) {
      case "hi":
        return Hindi;
      case "bho":
        return Bhojpuri;
      case "pa":
        return Punjabi;
      case "en":
      default:
        return English;
    }
  };
  
  export default useTranslation;